import React, { Fragment } from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { useAppContext } from 'Context/ReactAppContext';
import { TRACK_EVENT_NAMES } from 'Tracking/constants';
import { useTrackEvent } from 'Tracking/tracking-api/useTrackEvent';
import { formatAmountForLocale } from 'Utils/currency-config-for-locale/currencyConfigForLocale';
import { Icon } from 'Components/frameworks/icon/Icon';
import { updateBookingCart } from './cart.actions';
import { DashLine } from './DashLine';
type Props = {
  bookingId: string;
  item: CartChildcare;
  serviceName: ServiceType;
  stayIndex: number;
  serviceProductInfo: UpsellChildcareProductInfo | null | undefined;
  updateCart: typeof updateBookingCart;
  isCartLocked?: boolean;
};
export const CartServiceItem = ({
  item,
  updateCart,
  bookingId,
  serviceName,
  stayIndex,
  serviceProductInfo,
  isCartLocked = false,
}: Props) => {
  const context = useAppContext();
  const { trackClickEvent } = useTrackEvent();

  const removeFromCart = (attendeeId) => {
    const attendees = item.attendees.map((a) => ({
      id: a.id,
    }));

    if (attendees.length === 1) {
      updateCart({
        id: item.id,
        bookingId,
        context: context,
        action: 'remove',
        serviceName,
        stayIndex,
      });
    } else {
      const index = attendees.findIndex(({ id }) => id === attendeeId);
      attendees.splice(index, 1);
      const schedules = item.schedules.map((schedule) => {
        const attendeesInSchedule = schedule.attendees
          .filter(({ id }) => id !== attendeeId)
          .map((attendee) => ({
            id: attendee.id,
          }));
        return {
          start_date: schedule.startDate,
          end_date: schedule.endDate,
          attendees: attendeesInSchedule,
        };
      });
      updateCart({
        id: item.id,
        bookingId,
        schedules,
        context: context,
        action: 'update',
        serviceName,
        stayIndex,
      });
    }

    trackClickEvent(TRACK_EVENT_NAMES.CLICK_CART, {
      detail_click: `remove_${serviceName.toLowerCase()}`,
    });
  };

  return (
    <Fragment>
      {item.attendees.map((attendee, i) => {
        const serviceTotalPricePerAttendee = item.schedules.reduce((totalPrice, schedule) => {
          const attendeeInSchedules = schedule.attendees.find(({ id }) => id === attendee.id);
          return attendeeInSchedules ? totalPrice + attendeeInSchedules.price : totalPrice;
        }, 0);
        return (
          <Fragment key={attendee.id}>
            <div className="flex justify-between gap-10 text-14">
              {serviceProductInfo?.label}
              <div className="flex items-center gap-10">
                {formatAmountForLocale(serviceTotalPricePerAttendee, context.locale)}
                {!isCartLocked && (
                  <button
                    className="leaading-0"
                    onClick={() => removeFromCart(attendee.id)}
                    type="button"
                  >
                    <Icon name={ICONS.CROSS} width="0.8rem" />
                  </button>
                )}
              </div>
            </div>
            {i !== item.attendees.length - 1 && <DashLine />}
          </Fragment>
        );
      })}
    </Fragment>
  );
};
